const newrelic = window.newrelic || null;

if (newrelic) {
  const ignoreErrors = [
    'resizeobserver',
    'mainSectionCustom', // Known fundraise up error
    '_AutofillCallbackHandler', // Safari autofill error
  ]

  newrelic.setErrorHandler(function(err) {
    const message = err.message || '';
    const name = err.name || '';
    const code = err.code || '';

    if (!message) {
      return false;
    }
    
    if (ignoreErrors.some(ignored => message.toLowerCase().includes(ignored.toLowerCase()))) {
      return true;
    }

    // Ignore aborted requests if user-initiated
    if (message.includes('Unhandled Promise Rejection: Request aborted')) {
      // User-initiated cancellations - ignore
      if (name === 'CanceledError' || name === 'AbortError') {
        return true;
      }
      
      if (code === 'ERR_CANCELED') {
        return true;
      }
    }
    
    return false;
  });
}

export { newrelic };
